export const MENULIST = {
  DEFAULT_MENU: {
    WELCOME_MESSAGE: {
      name: 'welcome_message',
      icon: 'fa fa-handshake-o',
      path: 'welcome'
    },
    CONVERSATION: {
      name: 'conversation',
      icon: 'fa fa-comments',
      path: 'conversation'
    },
    REPLY_COMMENT: {
      name: 'reply_comment',
      icon: 'fa fa-reply',
      path: 'comment'
    },
    BROADCAST: {
      name: 'broadcast',
      icon: 'fas fa-bullhorn',
      path: 'broadcast'
    },
    TICKETING: {
      name: 'ticketing',
      icon: 'fas fa-ticket-alt',
      path: 'ticket'
    },
    LIVECHAT: {
      name: 'livechat',
      icon: 'fa fa-commenting',
      path: 'allinonechat'
    },
    ANALYTICS: {
      name: 'analytics',
      icon: 'fa fa-bar-chart',
      path: 'dashboard'
    },
    TRAINING: {
      name: 'training',
      icon: 'fas fa-dumbbell',
      path: 'training'
    },
    SETTING: {
      name: 'setting',
      icon: 'fa fa-cog',
      path: 'billing'
    }
  },

  CUSTOMIZE_MENU: {
    TCP: {
      BROADCAST: {
        name: 'broadcast',
        icon: 'fas fa-bullhorn',
        path: 'tcp/broadcast'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/menuList.js